import { HttpErrorResponse } from '@angular/common/http';

// Part Despatch Not Allowed (4Spaces/Ross, 28 Sep 2026): the words for the two coded answers the API
// gives when an order must leave WHOLE. One place, because five screens show them - three of which
// used to swallow the refusal altogether. The API sends codes, not prose (api.md, the shape of a
// refusal), so the text is worded - and translated - here.

/** The refusal `{ code: 'PartDespatchNotAllowed', orderNos }` in words, or null for any other error. */
export function partDespatchRefusalMessage(error: HttpErrorResponse): string | null {
  if (error?.error?.code !== 'PartDespatchNotAllowed') {
    return null;
  }

  const orderNos = ((error.error.orderNos as number[]) ?? []).join(', ');
  return orderNos
    ? $localize`Orders that do not allow part despatch: ${orderNos}. Every line must be fully picked, and all of the order's items despatched together.`
    : $localize`The order does not allow part despatch. Every line must be fully picked, and all of the order's items despatched together.`;
}

/**
 * The warning for `{ code: 'PartDespatchWholeOrder', action, orderNo, itemCount }` - a one-at-a-time
 * tab asked to move ONE item of such an order, which moves the WHOLE order once the user agrees
 * (D-16). Null for any other error. `target` is what the items are going onto or coming off.
 */
export function partDespatchWholeOrderWarning(
  error: HttpErrorResponse,
  target: 'despatchNote' | 'invoice',
): string | null {
  if (error?.error?.code !== 'PartDespatchWholeOrder') {
    return null;
  }

  const orderNo = error.error.orderNo as number;
  const itemCount = error.error.itemCount as number;

  if (error.error.action === 'remove') {
    // Taking an item off an invoice also takes it off its despatch note, so the rule applies there too
    // (Ross Un-do routines, D-1(d)).
    return target === 'invoice'
      ? $localize`Order ${orderNo} does not allow part despatch, so all of its items will be taken off this invoice and its despatch note together. Items: ${itemCount}`
      : $localize`Order ${orderNo} does not allow part despatch, so all of its items will be taken off this despatch note together. Items: ${itemCount}`;
  }

  return target === 'invoice'
    ? $localize`Order ${orderNo} does not allow part despatch, so all of its items will be added to this invoice and its despatch note together. Items: ${itemCount}`
    : $localize`Order ${orderNo} does not allow part despatch, so all of its items will be added to this despatch note together. Items: ${itemCount}`;
}
